import React from "react";
import CustomText from "pages/_components/CustomText/CustomText";
import Image from "pages/_components/Image";
import classNames from "classnames";

import { customDataPropType, defaultCustomDataPropType } from "./customDataPropType";

const CustomData = (props) => {
    const {
        icon,
        dataClass,
        titleClass,
        titleText,
        titleTextType,
        keepSpaceIfNotitle,
        valueClass,
        valueText,
        valueTextType,
        keepSpaceIfNoValue,
        hideTitleDesktop,
        isDesktop,
        wrapperClassName,
        addWrapper,
        withPrintFormat,
        showTooltip,
        onTooltipClick,
    } = props;

    const renderContent = () => (
        <>
            {!!icon && <Image src={icon} alt="icon" />}
            {!(hideTitleDesktop && isDesktop) && (
                <CustomText
                    text={titleText}
                    textType={titleTextType}
                    keepSpaceIfNoText={keepSpaceIfNotitle}
                    className={`custom-data-title ${titleClass}`}
                    showTooltip={showTooltip}
                    onTooltipClick={onTooltipClick}
                />
            )}
            {withPrintFormat && <span className="show-print">{": "}</span>}
            {/* Value */}
            <CustomText
                text={valueText}
                textType={valueTextType}
                keepSpaceIfNoText={keepSpaceIfNoValue}
                className={`custom-data-value ${valueClass}`}
            />
        </>
    );
    return !!titleText?.length || (keepSpaceIfNotitle && (!!valueText?.length || keepSpaceIfNoValue)) ? (
        <div className={`custom-data ${dataClass}${icon?.length ? " with-icon" : ""}`}>
            {addWrapper ? (
                <div className={classNames("custom-data-wrapper", wrapperClassName)}>
                    <div>{renderContent()}</div>
                </div>
            ) : (
                renderContent()
            )}
        </div>
    ) : null;
};

CustomData.propTypes = customDataPropType;
CustomData.defaultProps = defaultCustomDataPropType;

export default CustomData;
